export class AckFlagModel{
    enrollmentId:number;   
    flag:boolean;
    constructor(id,flag){
        this.enrollmentId=id;
        this.flag=flag;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/AckFlag.model.ts